import { Component, OnInit } from '@angular/core';
import {Subscription} from 'rxjs';
import {SharedServiceService} from '../../services/shared-service.service';

@Component({
  selector: 'app-rotate-phone-lock',
  templateUrl: './rotate-phone-lock.component.html',
  styleUrls: ['./rotate-phone-lock.component.scss']
})
export class RotatePhoneLockComponent implements OnInit {
  orientaionChange: Subscription;
  isOrientaionChanged = false;
  constructor(private sharedService: SharedServiceService) { }

  ngOnInit() {
    this.orientaionChange =
      this.sharedService.onorientationchange
        .subscribe(status => {
          this.isOrientaionChanged = status;
        });
  }

}
